import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initNeighborhoodAnimation() {
  const section = document.querySelector('.neighborhood-section');
  if (!section) return;

  // Set initial states - static elements start invisible (desktop)
  gsap.set('.neighborhood-illustration__desktop .fade-in', { 
    autoAlpha: 0 
  });

  // Set initial states - pins start invisible (desktop)
  gsap.set([
    '#left-pin',
    '#right-pin'
  ], { 
    autoAlpha: 0 
  });

  // Set initial states - dashed connector starts invisible (desktop)
  gsap.set('#dashed-connector', { 
    autoAlpha: 0 
  });

  // Set initial states - static elements start invisible (mobile)
  gsap.set('.neighborhood-illustration__mobile .fade-in', { 
    autoAlpha: 0 
  });

  // Set initial states - pins start invisible (mobile)
  gsap.set([
    '#m-left-pin',
    '#m-right-pin'
  ], { 
    autoAlpha: 0 
  });

  // Set initial states - dashed connector starts invisible (mobile)
  gsap.set('#m-dashed-connector', { 
    autoAlpha: 0 
  });

  // Setup desktop dashed connector (left to right)
  const dashedPath = document.querySelector('#dashed-connector');
  if (dashedPath) {
    const svg = dashedPath.closest('svg');
    const bbox = dashedPath.getBBox();
    
    // Create clipPath
    const defs = svg.querySelector('defs') || svg.insertBefore(document.createElementNS('http://www.w3.org/2000/svg', 'defs'), svg.firstChild);
    const clipPath = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
    clipPath.setAttribute('id', 'dashed-connector-clip');
    const clipRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    clipRect.setAttribute('x', bbox.x);
    clipRect.setAttribute('y', bbox.y);
    clipRect.setAttribute('width', 0);
    clipRect.setAttribute('height', bbox.height);
    clipPath.appendChild(clipRect);
    defs.appendChild(clipPath);
    
    dashedPath.setAttribute('clip-path', 'url(#dashed-connector-clip)');
    
    // Store the clipRect for animation
    dashedPath.clipRect = clipRect;
    dashedPath.clipWidth = bbox.width;
  }

  // Setup mobile dashed connector (top to bottom)
  const mDashedPath = document.querySelector('#m-dashed-connector');
  if (mDashedPath) {
    const svg = mDashedPath.closest('svg');
    const bbox = mDashedPath.getBBox();
    
    // Create clipPath
    const defs = svg.querySelector('defs') || svg.insertBefore(document.createElementNS('http://www.w3.org/2000/svg', 'defs'), svg.firstChild);
    const clipPath = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
    clipPath.setAttribute('id', 'm-dashed-connector-clip');
    const clipRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    clipRect.setAttribute('x', bbox.x);
    clipRect.setAttribute('y', bbox.y);
    clipRect.setAttribute('width', bbox.width);
    clipRect.setAttribute('height', 0);
    clipPath.appendChild(clipRect);
    defs.appendChild(clipPath);
    
    mDashedPath.setAttribute('clip-path', 'url(#m-dashed-connector-clip)');
    
    // Store the clipRect for animation
    mDashedPath.clipRect = clipRect;
    mDashedPath.clipHeight = bbox.height;
  }

  // Early fade-in for static elements and pins (desktop) - triggers earlier in viewport
  ScrollTrigger.create({
    trigger: section,
    start: 'top 85%',
    once: true,
    onEnter: () => {
      gsap.to(['.neighborhood-illustration__desktop .fade-in', '#left-pin', '#right-pin'], {
        autoAlpha: 1,
        duration: 1.5,
        ease: 'power2.out'
      });
    }
  });

  // Early fade-in for static elements and pins (mobile) - triggers earlier in viewport
  ScrollTrigger.create({
    trigger: section,
    start: 'top 85%',
    once: true,
    onEnter: () => {
      gsap.to(['.neighborhood-illustration__mobile .fade-in', '#m-left-pin', '#m-right-pin'], {
        autoAlpha: 1,
        duration: 1.5,
        ease: 'power2.out'
      });
    }
  });

  // Dashed line animation (desktop) - triggers when higher in viewport
  // Pins already visible from earlier fade-in, just animate the line
  ScrollTrigger.create({
    trigger: section,
    start: 'top 60%',
    once: true,
    onEnter: () => {
      const tl = gsap.timeline();
      
      // Dashed line draws from left to right with longer ease-out
      tl.to('#dashed-connector', { autoAlpha: 1, duration: 0.1 })
        .to(dashedPath?.clipRect, {
          attr: { width: dashedPath?.clipWidth || 0 },
          duration: 1.5,
          ease: 'power3.out'
        }, '-=0.1');
    }
  });

  // Dashed line animation (mobile) - triggers when higher in viewport
  // Pins already visible from earlier fade-in, just animate the line
  ScrollTrigger.create({
    trigger: section,
    start: 'top 60%',
    once: true,
    onEnter: () => {
      const tlMobile = gsap.timeline();
      
      // Dashed line draws from top to bottom with longer ease-out
      tlMobile.to('#m-dashed-connector', { autoAlpha: 1, duration: 0.1 })
        .to(mDashedPath?.clipRect, {
          attr: { height: mDashedPath?.clipHeight || 0 },
          duration: 1.5,
          ease: 'power3.out'
        }, '-=0.1');
    }
  });
}
